
const AdditionalFormLayout = [
    {
        "groupId": 1,
        "label": "Freight Charges",
        "fields": [
            {
                "name": "FREIGHTCHARGETYPE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Type:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false,
            }, {
                "name": "R_FREIGHTBILLTO",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Bill To ID:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }, {
                "name": "FREIGHTAMOUNT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Amount",
                "type": "number", "format":"#,###0.00",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    }, {
        "groupId": 2,
        "label": "Receipt Hold/Off Hold",
        "fields": [
            {
                "name": "RECEIPTPUTONHOLD",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Rec. Put On Hold:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            },
            {
                "name": "AVAILABLEREASONCODE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reason Of Hold:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            },
            {
                "name": "HOLDREASONCODE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Hold Reason Code:",
                "type": "text",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            },
            {
                "name": "HOLDDAYSCOUNT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "No. of Days on hold:",
                "type": "number", "format":"#,###0",
                "options": null,
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true
            }
        ]
    },{
        "groupId": 3,
        "label": "Accounting",
        "fields": [
            {
                "name": "R_GLDEPARTMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Department:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "ignoredblocalization": true
            },
            {
                "name": "R_GLFUND",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "FA Fund:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "ignoredblocalization": true
            },
            {
                "name": "R_CAJOB",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CA Job:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "ignoredblocalization": true
            }
        ]
    },{
        "groupId": 4,
        "label": "Stage/Status/Order Details",
        "fields": [
            {
                "name": "RFTRANSACTION",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RF Flag:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "readOnly": true,
                "searchEnabled": false,
                "isLabelChanged": true,
                
            },
            {
                "name": "RFGROUP",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "RF Group:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
                
            }
        ]
    },{
        "groupId": 5,
        "label": "Print Flags",
        "fields": [
            {
                "name": "PRINTRECEIPT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Confirmation:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            } ,     {
                "name": "PRINTBOL",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "BOL:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            } ,     {
                "name": "PRINTPICKINGSLIP",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Picking Slip:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            } ,     {
                "name": "SENDFAX",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Send Fax:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            } , {
                "name": "PRINTSERIALNUMBERMANIFEST",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Manifest:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            }, {
                "name": "PRINTRECEIPTPUTAWAY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            }
        ]
    },{
        "groupId": 6,
        "label": "EDI Sent",
        "fields": [
            {
                "name": "EDITRANSMIT_CARRIER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Carrier:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            }, {
                "name": "EDITRANSMIT_CUSTOMER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            },
            {
                "name": "EDITRANSMIT_CONSIGNEE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Consignee:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            },
            {
                "name": "EDITRANSMIT_SHIPPER",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Shipper:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true,
                "searchEnabled": false
            }
        ]
    }
];
export default AdditionalFormLayout;